import React, {useState} from 'react';
import {useRef} from 'react';

import AudioPlayer from './AudioPlayer';

interface Props {
    audiobookId?: string;
    audiobookDictionary?: any;
}

const AudiobookPlayer = ({audiobookId, audiobookDictionary}: Props) => {
    // debugger;
    const lastPlayedJson = localStorage.getItem('lastPlayed');
    let savedTrackId = null;

    if (lastPlayedJson !== null) {
        const lastPlayed = JSON.parse(lastPlayedJson);
        if (lastPlayed && lastPlayed.trackId) {
            savedTrackId = lastPlayed.trackId;
        }
    }

    let savedCurrentTime = 0;

    if (lastPlayedJson !== null) {
        const lastPlayed = JSON.parse(lastPlayedJson);
        if (lastPlayed && lastPlayed.currentTime) {
            savedCurrentTime = lastPlayed.currentTime;
        }
    }

    const [selectedTrack, setSelectedTrack] = useState<string | null>(savedTrackId);
    const [selectedCurrentTime, setSelectedCurrentTime] = useState<number | null>(savedCurrentTime);

    const handleTrackSelect = (trackId: string) => {
        setSelectedTrack(trackId);
    };

    const focusRef = useRef(null);

    return (

        <div>

            {selectedTrack &&

                (

                    <div>
                        <center>

                            כרגע מנגן :

                        </center>
                        <center>

                            <h3>
                                {selectedTrack}
                            </h3>
                        </center>
    <AudioPlayer
        setSelectedTrack={setSelectedTrack}
        audiobookId={audiobookId}
        selectedCurrentTime={selectedCurrentTime}
        trackId={selectedTrack}
        audiobookDictionary={audiobookDictionary}
    />



                    </div>
            )}
            {/*<center>*/}

                <h2>רשימת פרקים</h2>
                <ul>
                    {Object.keys(audiobookDictionary).map((trackId) => (
                        <li key={trackId}>

                            <a

                                style={{
                                    backgroundColor: selectedTrack === trackId ? 'green' : 'transparent',
                                }} // Apply the green background color if selectedTrack matches trackId
                                href="#"
                                onClick={() => {
                                    handleTrackSelect(trackId)
                                    // debugger;
                                    // focusRef.current && focusRef.current.focus();
                                }}
                                ref={selectedTrack === trackId ? focusRef : null}
                            >
                                {trackId}
                            </a>
                        </li>
                    ))}
                </ul>
            {/*</center>*/}



        </div>
    );
};

export default AudiobookPlayer;
